<template>
  <div ref="app" id="app" class="app-bgcolor">
    <Notifications />
    <Header />
    <Empty
      v-if="set.items.length === 0 && config.visualMode !== 'wishlist'"
    ></Empty>
    <section v-if="set.items.length > 0 || config.visualMode === 'wishlist'">
      <Loading />
      <Wishlist v-if="config.visualMode === 'wishlist'"></Wishlist>
      <ImageViewer v-else-if="config.visualMode === 'images'"></ImageViewer>
      <Set
        v-if="
          config.visualMode !== 'wishlist' && config.visualMode !== 'images'
        "
      ></Set>
    </section>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Loading from "./components/Loading.vue";
import ImageViewer from "@/components/ImageViewer";
import Set from "./components/Set.vue";
import Empty from "./components/Empty";
import Wishlist from "./components/Wishlist";
import Notifications from "@/components/Notifications";

import Url from "@/assets/Url";
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

import CatchFetch from "@/assets/Cache/Fetch";

import DAOEngraving from "@/assets/DAO/Engraving";

import "@/vuex/Watcher.js";
import Logger from "@/assets/Helper/Logger";
import Status from "@/vuex/Status";
import MenuList from "@/assets/Helper/MenuList";
import MediaQuery from "@/assets/Helper/MediaQuery";

export default {
  name: "app",
  components: {
    Empty,
    Set,
    Header,
    Loading,
    Wishlist,
    Notifications,
    ImageViewer,
  },
  data() {
    return {
      set: SetData.getters.getSet,
      config: Config.getters.getConfig,
      resizing: false,
      resizeTriggered: false,
      windowWidth: 0,
      hideImage: {
        set: false,
        overview: false,
        all: false,
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
      },
      Viewer3d: null,
      Viewer3dSet: null,
    };
  },
  updated() {
    if (history && history.state != null && history.state.ispopstate == true) {
      this.resetHideImageArray(
        SetData.getters.getShowSetImage ? "set" : "overview"
      );
    }
  },
  created() {
    this.windowWidth = window.innerWidth;

    window.addEventListener("resize", this.resize);

    if (typeof window.conf2020AppConfig == "object") {
      if (typeof window.conf2020AppConfig.urlPrafix == "string") {
        Config.dispatch(
          "setIntegrationUrlPrafix",
          window.conf2020AppConfig.urlPrafix
        );
      }
      if (
        typeof window.conf2020AppConfig.country == "string" &&
        typeof window.conf2020AppConfig.language == "string"
      ) {
        Config.dispatch("setCountry", window.conf2020AppConfig.country);
        Config.dispatch("setLanguage", window.conf2020AppConfig.language);

        this.$root.$i18n.locale =
          window.conf2020AppConfig.language.toLowerCase() +
          "-" +
          window.conf2020AppConfig.country.toUpperCase();
      }

      let analyticsId =
        typeof window.conf2020AppConfig.analyticsId === "string" &&
        window.conf2020AppConfig.analyticsId !== ""
          ? window.conf2020AppConfig.analyticsId
          : "";

      if (typeof window.conf2020AppConfig.tracking === "boolean") {
        if (window.conf2020AppConfig.tracking === false || analyticsId === "") {
          Logger.debug("Tracking is disabled");
        } else {
          Logger.debug("Tracking is enabled");
        }
      }
      if (typeof window.conf2020AppConfig.shopLogin === "object") {
        if (
          ((typeof window.conf2020AppConfig.shopLogin.shopId === "number" &&
            window.conf2020AppConfig.shopLogin.shopId > 10000) ||
            (typeof window.conf2020AppConfig.shopLogin.shopId === "string" &&
              parseInt(window.conf2020AppConfig.shopLogin.shopId) > 10000)) &&
          (window.conf2020AppConfig.shopLogin.isActive === true ||
            window.conf2020AppConfig.shopLogin.isActive === "yes")
        ) {
          Config.dispatch(
            "setShopId",
            parseInt(window.conf2020AppConfig.shopLogin.shopId)
          );
          Logger.debug("Shop login is active");
        } else {
          Logger.debug("Shop login is disabled");
        }
      }
      if (typeof window.conf2020AppConfig.website === "string") {
        Config.dispatch("setWebsite", window.conf2020AppConfig.website);
      }
      if (typeof window.conf2020AppConfig.isOnlyWishlist === "boolean") {
        Config.dispatch(
          "setIsOnlyWishlist",
          window.conf2020AppConfig.isOnlyWishlist
        );
        this.config.visualMode = "wishlist";
      }
    }

    CatchFetch.init();
    CatchFetch.clear();

    Url.getItemnumbers();

    DAOEngraving.get();

    let showInitialMsg = localStorage.getItem("showInitialMsg");
    if (
      (typeof showInitialMsg === "string" && showInitialMsg === "false") ||
      showInitialMsg === false
    ) {
      Status.dispatch("setInitialMsg", false);
    }

    if (MediaQuery.isBreakpointMD()) {
      Config.dispatch("setShowSideMenu", false);
    } else if (MediaQuery.isDesktop) {
      Config.dispatch("setShowSideMenu", true);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    correctSetId: function (setId) {
      if (setId.substr(setId.length - 1, setId.length) === "-") {
        setId += "1";
      }
      return setId.toLowerCase();
    },
    isInMenuList(itemId) {
      let menuList = MenuList.get(itemId);
      let currentVarTypeTmp = Config.getters.getcurrentVarType;
      if (
        currentVarTypeTmp.indexOf("stones") < 0 ||
        currentVarTypeTmp === "stones/diamondExchange"
      ) {
        if (!menuList[currentVarTypeTmp]) {
          return false;
        }
      }
      return true;
    },
    resize: function () {
      if (this.windowWidth != window.innerWidth) {
        // Bug-Fix Safari -> Scrolling triggers resize
        this.windowWidth = window.innerWidth;
      }
    },
    openPicture(imgSrc) {
      let imgSrcParts = imgSrc.split("&");

      if (imgSrcParts.length > 1) {
        imgSrc = "";
        for (let i in imgSrcParts) {
          if (
            imgSrcParts[i].indexOf("width") < 0 &&
            imgSrcParts[i].indexOf("height") < 0
          ) {
            imgSrc += imgSrcParts[i] + "&";
          }
        }
        imgSrc = imgSrc.substring(0, imgSrc.length - 1);
      }

      window.open(imgSrc);
    },
    resetHideImageArray: function (newCurrentItem) {
      let lastCurrentItem = this.getCurrentItemFromHideImage();
      let lastCurrentItemState = this.hideImage[lastCurrentItem];

      for (let index in this.hideImage) {
        this.hideImage[index] = false;
      }

      if (
        newCurrentItem !== "set" &&
        typeof this.hideImage[newCurrentItem] == "boolean" &&
        lastCurrentItemState === true
      ) {
        this.hideImage[newCurrentItem] = true;
      }
    },
    getCurrentItemFromHideImage: function () {
      let currentItemId = SetData.getters.getCurrentItemId;
      for (let index in this.hideImage) {
        if (this.hideImage[index] === true) {
          currentItemId = index;
        }
      }
      return currentItemId;
    },
    reset3d: function (updateViewer) {
      SetData.dispatch("setItemDescription3d", {}).then(() => {
        if (updateViewer === true) {
          this.$root.$emit("updateViewer");
        }
      });
    },
    setCurrentItem: function (currentItem) {
      let currentItemOrig = currentItem;

      if (this.set.items.length < 2) {
        currentItem = "overview";
      }

      this.resetHideImageArray(currentItem);
      SetData.dispatch("setCurrentItem", currentItemOrig).then(() => {
        if (!isNaN(currentItemOrig)) {
          this.$root.$emit("setJewelleryTypeForEngraving");
        }
      });
    },
  },
};
</script>

<style lang="scss">
:root {
  font-size: 10px;
}

html,
body {
  font-family: Roboto-Light, sans-serif;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background-color: $darkGrey;

  .main-header {
    z-index: 999 !important;
    position: relative !important;
  }
}

#app {
  height: 100%;
  all: unset;
  font-family: Roboto-Light, sans-serif;
  font-variant-ligatures: none;
  text-rendering: optimizeSpeed;
  font-size: 1.6rem;
  color: $fontColor;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ul.default-option-list {
    text-align: center;
    padding: 1.5rem;
    margin: 0 0 0 0;

    li {
      display: inline-flex;
      align-items: center;
      overflow: hidden;
      padding: 0 0 1.5rem 0;
      margin: 0.75rem 0;
      border: none;
      vertical-align: top;
      cursor: pointer;
      text-align: left;
      width: 100%;
      border-bottom: 0.1rem solid #ccc;

      &:last-child {
        border-bottom: none;
      }

      img {
        height: auto;
        display: inline-flex;
      }

      p {
        margin: 0 0 0 0;
        padding-left: 1.5rem;
        font-size: 1.6rem;
        width: 85%;
        display: inline-flex;
        align-items: center;

        span:first-child {
          padding-top: 1rem;
        }
      }
    }

    li.match {
      font-weight: bold;
      background-color: inherit;
      color: $black;

      img {
        border: solid 0.2rem $brandGold;
        border-radius: 5em;
      }
    }
  }

  .form-control {
    font-size: 1.6rem;
  }

  input {
    font-size: 1.4rem;
  }

  select {
    min-width: 15rem;
    border: 1px solid #ced4da;
  }

  .input-group-text {
    font-size: 1.4rem;
  }

  .text-end {
    &:not(.no-flex) {
      display: flex;
      justify-content: flex-end;
    }

    &.no-flex {
      text-align: right !important;
    }
  }

  .icon {
    width: 1.5em;
    margin: 0.4rem 0 0.5rem 0.5rem;
    cursor: pointer;

    &.open {
      margin-top: 1rem;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    text-align: left;
    font-size: 1.8rem;
    margin-top: 0.5em;
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 0.5em;
  }

  h5 {
    font-weight: bold;
    font-size: 1.8rem;
    margin-bottom: 0;
  }

  h5.uppercase {
    letter-spacing: 0.05em;
  }

  .hl-variation-list {
    text-align: left;
    font-weight: bold;
    padding: 0;
  }

  hr {
    margin: 0;
    border-top: 1px solid $brandColorLine;
  }

  .border-bottom {
    padding-bottom: 0.5em;
    border-bottom: solid 0.1em $brandDarkGrey;
    margin-bottom: 1em;
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1rem 0 0 0;
    width: fit-content;
    padding: 1.2rem 1.2rem;
    font-size: 1.6rem;
    font-weight: 500;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.15s ease, color 0.15s ease,
      border-color 0.15s ease;

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 0.2rem solid #000000;
      outline-offset: 0.2rem;
    }
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
    border: 0.1rem solid #000000;
    padding: 1.2rem 0.6rem;

    &.btn-secondary {
      border-color: rgb(204, 204, 204);
    }

    @media (min-width: 768px) {
      width: fit-content;
    }
  }

  .btn-primary {
    color: #ffffff;
    background-color: #000000;

    &:hover {
      background-color: #666666;
      border-color: #666666;
    }
  }

  .btn-secondary {
    color: #000000;
    background-color: #ffffff;

    &:hover {
      background-color: #f8f8f8;
    }
  }

  &.text-link {
    color: #000000;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-transform: none;
    font-size: 2rem;
    border: none;
    margin: 2.4rem 0 0.75rem 0;
    padding: 0;
    text-decoration: underline;
    justify-content: start;
    background: none;
    text-align: left;
  }

  .btn-block {
    width: 100% !important;
  }

  a {
    color: $fontColor;
    cursor: pointer;
  }

  section {
    padding: 0;
    margin: 0;
  }

  img.thumb,
  img.set-thumb {
    display: block;
    width: 5rem;
    height: 5rem;
    border-radius: 5em;
    border: solid 0.1rem $brandColorLine;
  }

  div.crop-img {
    display: inline-flex;
    width: 10rem;
    height: 10rem;
    border-radius: 5em;
    border: solid 0.1rem $imgBorderGrey;
    overflow: hidden;

    img {
      width: 10em !important;
    }
  }
}

#app h1.text-center,
#app h2.text-center,
#app h3.text-center,
#app h4.text-center,
#app h5.text-center,
#app h6.text-center {
  text-align: center;
}

#app p {
  font-size: 1.6rem;
  padding: 0;
}

.app-bgcolor {
  background-color: #ffffff;
}

.image-bdcolor {
  background-color: #444444;
}

.white-bgcolor {
  background-color: #ffffff;
}

.red-bgcolor {
  background-color: #a04f55;
  color: #ffffff;
}

.color-D9D9D9 {
  color: #d9d9d9 !important;
}

#app .pointer {
  cursor: pointer !important;
}

#app .no-scrollbar {
  overflow: auto; /* oder overflow-x / overflow-y */
  -ms-overflow-style: none; /* IE und alte Edge */
  scrollbar-width: none; /* Firefox */
}

#app .no-scrollbar::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
</style>
